<span style="white-space: pre-line" class="" ngClass="{{statusClass}}"> 
  {{statusText}}  
</span> 
